export default __webpack_public_path__ + "static/media/overview_banner.dd80c4dc.png";